import fetchOptions from "./fetchOptions";
import store from "../redux/store/userStore";
import {errorUserData} from "../redux/Actions/UserDataActions";

export const consentService = {

    saveConsents: async (vin) => {
        const response = await
            fetch(`${process.env.REACT_APP_BACKEND_URL}/consent`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                accept: "application/json",
                "auth-token": window?.fma?.["CATBundle"]?.["access_token"] ?? null,
                "application-id": process.env.REACT_APP_APPLICATION_ID,
            },
            body: JSON.stringify({
                vin: vin
            })
        });

        try{
            const data = await response.json();

            if (response.ok) {
                return data
            } else {
                store.dispatch(errorUserData(data));
            }
        }catch (e){
            console.log(e)
        }
    }
};
